import { parseTimeout } from "@/shared/domain/actions";

export const handleTimeoutOnChangeState = (
  event: React.ChangeEvent<HTMLInputElement>,
  setCurrentValue: (arg: number | string | undefined) => void,
) => {
  const val = event.target.value;
  if (val === undefined || val === "") {
    setCurrentValue(undefined);
    return;
  }
  const parsed = parseTimeout(val);
  if (Number.isNaN(parsed)) {
    // The customer-supplied value is not a number; set whatever was given to trigger the error state
    setCurrentValue(event.target.value);
    return;
  }

  setCurrentValue(parsed);
};

export const createInitialTimeoutState = (isGated: boolean) => {
  if (isGated) {
    return 30;
  } else {
    return 720;
  }
};
